/* eslint-disable import/no-anonymous-default-export */
export default {
    static_images: {},
    apiCallsInProgress: 0,
};